import AbstractAdapter from 'adapters/AbstractAdapter';
import pickBy from 'lodash.pickby';
import snakeCase from 'lodash.snakecase';
import getRouteHref from 'router/utils/getRouteHref';
import vueRouterProxy from 'router/utils/vueRouterProxy';
import {getActualRouter} from 'router/utils/defineActualRouter';


export default class UrlAdapter extends AbstractAdapter {

  router = getActualRouter();

  getKeyAlias (key) {
    if (this.fieldParams[key].alias) {
      return this.fieldParams[key].alias;
    }
    return snakeCase(key);
  }

  saveStore () {

    /*
     * WARNING: this is legacy copypaste, because there is no native functions
     * to deal with get params after anchor (#)
     */

    if (Object.keys(this.store).length > 0) {
      const routeName = this.router.currentRoute.name;

      // todo: посмтреть, что я здемь ничего не сломал, в аргументе params
      const url = getRouteHref(routeName, {}, this.store);
      vueRouterProxy().navigate(url, {replace: true, trigger: false});
    }
    return this;
  }

  loadStore () {
    const data = this.router.currentRoute.query;

    // filter data, to prevent extra fields
    this.store = pickBy(data, (val, key) => this.allowedAliasesList.has(key));
  }
}
